import React, { Component } from "react";
import { Card, CardHeader, CardBody, Button, UncontrolledAlert } from "reactstrap";

import DataTable from "../../../Shared/DataTable";
import { MdDrafts, MdClear, MdAdd, MdSearch, MdDelete } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { MealPLanPage, UserEditMealPlan } from "../../../../_constants/RouteVariables";
import Moment from "moment";
//import { GoClock } from "react-icons/go";

const MockData = [
    {
        id: "5edf89e7541629640ffa6934",
        name: "yellowpawpaw",
        description: "yyyyyyyy",
        imageUrl: "https://mufasa-qa.interswitchng.com/p/verve-life-admin-service/resources/images/posts/b7488566-62e0-4470-996e-e6aa75d650cf.png",
        calories: 1.0,
        durationDays: 2,
        status: "PENDING",
        instructorId: "gloriaconcepto@outlook.com",
        updatedAt: "2020-06-09T13:09:30.861Z",
        createdAt: "2020-06-09T13:08:55.795Z",
        submittedAt: "2020-06-09T13:09:30.861Z",
        reviewedBy: null,
        reviewerRemarks: null,
        reviewedAt: null,
    },
    {
        id: "5edf8947541629640ffa6931",
        name: "finalTesting",
        description: "yyyyyyyy",
        imageUrl: "https://mufasa-qa.interswitchng.com/p/verve-life-admin-service/resources/images/posts/b6e19db9-25d3-407d-8e45-e84659706527.png",
        calories: 1.0,
        durationDays: 2,
        status: "PENDING",
        instructorId: "gloriaconcepto@outlook.com",
        updatedAt: "2020-06-09T13:07:13.624Z",
        createdAt: "2020-06-09T13:06:15.148Z",
        submittedAt: "2020-06-09T13:07:13.624Z",
        reviewedBy: null,
        reviewerRemarks: null,
        reviewedAt: null,
    },
    {
        id: "5edf8566541629640ffa692e",
        name: "ttttttt232324",
        description: "yyyyyyyy",
        imageUrl: "https://mufasa-qa.interswitchng.com/p/verve-life-admin-service/resources/images/posts/1fe4086b-1a43-421e-9657-94703ab2594a.png",
        calories: 1.0,
        durationDays: 2,
        status: "PENDING",
        instructorId: "gloriaconcepto@outlook.com",
        updatedAt: "2020-06-09T12:54:06.125Z",
        createdAt: "2020-06-09T12:49:42.625Z",
        submittedAt: "2020-06-09T12:54:06.125Z",
        reviewedBy: null,
        reviewerRemarks: null,
        reviewedAt: null,
    },
    {
        id: "5edf82b4541629640ffa692b",
        name: "wwwwwwwtest",
        description: "yyyyyyyy",
        imageUrl: "https://mufasa-qa.interswitchng.com/p/verve-life-admin-service/resources/images/posts/ac485204-3c9b-49dc-9c61-ea6e1af7ee73.png",
        calories: 1.0,
        durationDays: 2,
        status: "DRAFT",
        instructorId: "gloriaconcepto@outlook.com",
        updatedAt: "2020-06-09T12:38:12.089Z",
        createdAt: "2020-06-09T12:38:12.089Z",
        submittedAt: null,
        reviewedBy: null,
        reviewerRemarks: null,
        reviewedAt: null,
    },
    {
        id: "5edf72c2f5357b0aab4d03b9",
        name: "testingMealPlan222",
        description: "yyyyyyyy",
        imageUrl: "https://mufasa-qa.interswitchng.com/p/verve-life-admin-service/resources/images/posts/3e9647f6-62af-4a98-818d-caa4ffdbfadb.png",
        calories: 1.0,
        durationDays: 2,
        status: "DRAFT",
        instructorId: "gloriaconcepto@outlook.com",
        updatedAt: "2020-06-09T11:30:10.969Z",
        createdAt: "2020-06-09T11:30:10.969Z",
        submittedAt: null,
        reviewedBy: null,
        reviewerRemarks: null,
        reviewedAt: null,
    },
];

const Declined = () => {
    return (
        <span style={{ color: "red" }}>
            <MdClear /> Redraft
        </span>
    );
};

const Draft = () => {
    return (
        <span style={{ color: "#808080" }}>
            <MdDrafts /> Draft
        </span>
    );
};

export class DraftMealPlanTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: "all",
        };
    }

    filterDraftStatus = (data) => {
        let filterData = data
            .filter((value) => {
                return value.status !== "PENDING";
            })
            .filter((value) => {
                return value.status !== "APPROVED";
            })
            .filter((value) => {
                return value.status !== "DECLINED";
            })
            .map((value) => {
                return value;
            });

        return filterData;
    };

    render() {
        const columns = [
            {
                Header: "Name",
                accessor: "name",
            },

            {
                Header: "Date",
                id: "createdAt",
                maxWidth: 180,
                accessor: (d) => {
                    return Moment(d.createdAt).local().format("DD-MM-YYYY ");
                },
            },
            {
                Header: "Status",
                accessor: "status",

                id: "status",

                Cell: (row) => <span>{row.value === "DRAFT" ? <Draft /> : <Declined />}</span>,
            },
        ];

        const { match, fetching, data, error, selectRow, deleteInterest, showModal, pages, page, pageSize, setPageNumber, filterData, setPageSize } = this.props;

        const actions = [
            {
                name: "view",
                btnText: "View",
                isLink: true,
                isMealPLan: true,
                to: UserEditMealPlan,
                btnAction: selectRow,
                btnClass: "btn-success",
                btnIcon: MdSearch,
            },
            {
                name: "delete",
                btnText: "Delete",
                btnAction: showModal,
                btnClass: "btn-danger",
                btnIcon: MdDelete,
            },
        ];
        return (
            <div>
                <Card>
                    {/* <CardHeader>Draft Meal Plans</CardHeader> */}
                    <CardBody className="joyride10">
                        {error && <UncontrolledAlert color="danger">{error.message}</UncontrolledAlert>}
                        <NavLink to={MealPLanPage}>
                            <Button color="primary mb-2" size="sm">
                                <MdAdd /> Add Meal Plan
                            </Button>
                        </NavLink>
                        <DataTable
                            columns={columns}
                            loading={fetching}
                            urlParams={match}
                            // data={this.filterDraftStatus(MockData)}
                            data={data ? this.filterDraftStatus(data.data) : []}
                            count={data ? data.count : 0}
                            defaultPageSize={5}
                            deleteRow={deleteInterest}
                            selectRow={selectRow}
                            showModal={showModal}
                            manual={true}
                            pages={pages}
                            page={page}
                            pageSize={pageSize}
                            filterData={filterData}
                            //isView={true}
                            setPageNumber={setPageNumber}
                            setPageSize={setPageSize}
                            searchParam="searchKey"
                            hideSearchParam={true}
                            // searchPlaceholder="Search by title"
                            actions={actions}
                        />
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default DraftMealPlanTable;
